export default __webpack_public_path__ + "static/media/waspLogo.907ce25f.png";